import sanitizeHtml from 'sanitize-html';

export const sanitize = (html: string, tags: string[] = []): string => {
  // Default non allowed tags in documentation of sanitize-html package
  const defaultTags = ['style', 'script', 'textarea', 'option'];

  // Convert new lines to <br/> before sanitizing so line breaks are preserved
  const htmlWithLineBreaks = typeof html === 'string' ? html.replace(/\n/g, '<br />').replace(/<p><\/p>/g, '<p><br /></p>') : html;

  return sanitizeHtml(htmlWithLineBreaks, {
    allowedTags: sanitizeHtml.defaults.allowedTags.concat(['strike']),
    nonTextTags: [...defaultTags, ...tags],
  });
};
